import { useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

// ─── Utils ────────────────────────────────────────────────────────────────────
import DialogUtils from "../../utils/DialogUtils";

// ─── Services ─────────────────────────────────────────────────────────────────
import OnboardingCustomerService from "../../services/api/OnboardingCustomerService";

// ─── Assets ───────────────────────────────────────────────────────────────────
import logo from "../../assets/img/logo.jpg";
import "./less/_onboarding_account.less";

// ─── Services (module-level) ──────────────────────────────────────────────────
const onboardingCustomerService = new OnboardingCustomerService();

// ─── Types ────────────────────────────────────────────────────────────────────
interface ReauthOnBoardingAccountProps {
  // Define props if any are passed from the router
}

// ─── Component ────────────────────────────────────────────────────────────────
const ReauthOnBoardingAccount = (_props: ReauthOnBoardingAccountProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundColor = "white";
    checkHasOnboarding();

    return () => {
      // Cleanup: Reset background color when component unmounts
      document.body.style.backgroundColor = "";
    };
  }, []);

  const checkHasOnboarding = async () => {
    const result = await onboardingCustomerService.checkHasOnboarding();
    
    if (result?.details?.hasOnboarding) {
      const userString = localStorage.getItem("user") || "{}";
      const userObj = JSON.parse(userString);
      
      userObj.onboardingAccounts = result.details.onboarding_id;
      localStorage.setItem("user", JSON.stringify(userObj));
      
      // React Router 7 navigation
      navigate("/restaurant_detail");
    } else {
      create();
    }
  };

  const create = async () => {
    const result = await onboardingCustomerService.createLink();
    if (result?.details?.url) {
      window.location.href = result.details.url;
    } else {
      DialogUtils.error(
        "Something went wrong while creating the onboarding link. Please try again."
      );
    }
  };

  const existingAccount = async () => {
    const result = await onboardingCustomerService.createLinkExistingAccount();
    if (result) {
      window.location.href = result;
    } else {
      DialogUtils.error(
        "Something went wrong while creating the onboarding link. Please try again."
      );
    }
  };

  const cancel = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <div className="onboarding_main_div">
      <div className="onboarding_card" style={{ textAlign: "left" }}>
        <img src={logo} alt="appetit" className="onboarding_image" />
        <div className="onboarding_card_title">Merchant Onboarding</div>
        <div className="onboarding_card_body">
          You have no connected stripe account. Please create your account to
          allow your customers to order.
        </div>
        
        <Button 
          className="main-primary-btn btn-width-100p" 
          onClick={existingAccount}
        >
          EXISTING STRIPE ACCOUNT
        </Button>
        
        <Button 
          style={{ marginTop: 15 }} 
          className="main-primary-btn btn-width-100p" 
          onClick={create}
        >
          NEW STRIPE ACCOUNT
        </Button>
        
        <Button 
          className="main-primary-btn btn-width-100p" 
          style={{ marginTop: 15 }} 
          onClick={cancel} 
          disabled
        >
          CANCEL
        </Button>
      </div>
    </div>
  );
};

export default ReauthOnBoardingAccount;
